import { MainResponse } from "../main-response.model";
import { BlogItem } from "./blog-item.model";

export class BlogResponse extends MainResponse{
  constructor(obj = null) {
    super();
    obj = obj || {};
    this.init(obj);
    if (obj.object && obj.object instanceof Array) {
        obj.object.forEach((item) => {
            this.object = new BlogItem(item);
        })
    }
 }
}